<script>
import helpers from '@mixins/helper'
import {mapGetters} from 'vuex'

export default {
  mixins: [helpers],
  name: 'dashboard-link-form-popup',
  data () {
    return {
      mostrarModal: false
    }
  },
  mounted () {
    this.buscarPopup()
  },
  computed: {
    ...mapGetters(['currentUser', 'isLogged']),
    isMobileSize: function () {
      return this.isMobile().any()
    },
    primeiroNome: function () {
      if (this.isLogged) {
        let nome = (this.currentUser.pessoa.nome.split(' ')[0] || '').toLowerCase()
        return nome.charAt(0).toUpperCase() + nome.slice(1)
      }
      return ''
    }
  },
  methods: {
    buscarPopup () {
      this.currentUser.tipos_contratos_geral.forEach(item => {
        if (item.id === 1 || item.id === 15) {
          this.mostrarModal = true
        }
      })
    }
  }
}
</script>

<template>
  <div>
    <v-dialog v-model="mostrarModal"
              :width="isMobileSize ? '90%' : '40%'"
              persistent>
      <v-card class="popup-modal">
        <v-container>
          <h3 class="pb-3" :class="{'display-0': isMobileSize, 'display-1': !isMobileSize}">
            Dados Censo da Educação Superior
          </h3>
          <div class="text">
            <p :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
              Olá <strong>{{ primeiroNome }}</strong>, precisamos que você informe alguns dados para o Censo da Educação Superior 2024. É rápido e leva menos de um minuto. 
              <br><a :href="'https://docs.google.com/forms/d/e/1FAIpQLSedO4Oq1WxmgpRBL0DKPwTca0gX30IzorBAl7Ak15TkqG8IXQ/viewform?entry.521200124=' + currentUser.ref_pessoa" target="_blank"
                style="display: inline-block">
                Clique aqui para responder
            </a>
            <br>
            <br>
            <i>Se você já respondeu, por favor, desconsidere esta mensagem e clique em "<span @click="mostrarModal = false">Fechar</span>".</i>
            <br>
            </p>
          </div>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="mostrarModal = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// LinkFormPopup.vue?51cb0c44